import { FormatHelpers } from "../helpers/format-helpers";
import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { ChartStyleSettingsModel } from "../models/chart-style/chart-style-settings.model";
import { IComponent } from "./component.interface";

export class LastPriceComponent implements IComponent {
    public id = StringHelpers.newGuid();;

    private element: HTMLElement;
    private base: IChartContainer;
    private lastPrice = 0;
    private top = 0;
    
    private resizeTimmer = null as any;

    private lastPriceBgColor = '#32cd32';
    
    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
        this.subscribeLastPriceChange();
        this.onResize();
        
        this.base.tiChartSeries.subscribeExtremeChange(this.id, () => {
            clearTimeout(this.resizeTimmer);
            this.resizeTimmer = setTimeout(() => {
                this.setLastPriceLabelPosition();
            }, 250);
        });

        this.base.tiChartSeries.subscribeRedrawChange(this.id, () => {
            clearTimeout(this.resizeTimmer);
            this.resizeTimmer = setTimeout(() => {
                this.setLastPriceLabelPosition();
            }, 250);
        });

        this.subscribeChartService();
    }

    private subscribeLastPriceChange() {
        this.base.chartService.subscribeLastPriceData((price: number) => {
            this.lastPrice = price;
            this.setLastPriceLabelPosition();
        });
    }

    public hide() {
        this.element.classList.add('hidden');
    }
    
    public getElementTop(): number {
        return this.top;
    }

    public setLastPriceLabelPosition() {
        if (!this.base.tiChartSeries?.lastDataPoint || !this.base.tiChartSeries.highStockChart || !this.base.tiChartSeries.highStockChart.yAxis?.length) {
            return;
        }

        let lastPriceLine  = this.base.tiChartSeries.element.findFirst('.highcharts-crosshair.highcharts-crosshair-thin.main-series-last-price');
        lastPriceLine?.setAttribute('style', 'visibility: hidden; opacity: 0;')
        
        const yAxis: any = this.base.tiChartSeries.highStockChart.yAxis[0];
        if (!yAxis) {
            return;
        }
        
        let value = '';
        let close = 0;
        const root = document.documentElement;
        const chartStyle = this.base.tiChartSeries.chartStyleSettings;
        if (chartStyle?.isComparisonSymbolPercentageMode) {
            close = this.base.tiChartSeries.highChartComparisonBuilder.getPercentage(this.base.tiChartSeries.lastDataPoint);
            value = `${this.base.tiChartSeries.symbol} ${this.base.tiChartSeries.highChartComparisonBuilder.getPercentageAnnotationText(this.base.tiChartSeries.lastDataPoint)}`
            this.element.addClass('comparison-percentage');
            root.style.setProperty('--main-symbol-bg-color', chartStyle.selectedLineColor.toRGB());
        } else {
            close = this.base.tiChartSeries.lastDataPoint.close;
            if (!chartStyle?.getPrePostLastPriceDisabled) {
                close = this.lastPrice;
            }

            if (close < 1 && close != 0) {
                value = FormatHelpers.numberToString(close, 4);
            } else {
                value = FormatHelpers.numberToString(close);
            }

            this.element.removeClass('comparison-percentage');
            root.style.setProperty('--main-symbol-bg-color', this.lastPriceBgColor);
        }
        
        const currentValue =  yAxis.toPixels(close) ?? 0;
        const myHeight = this.element.clientHeight / 2;
        this.top = currentValue - myHeight;
        if (close >= yAxis.max) {
            const valueTop =  yAxis.toPixels(yAxis.max) ?? 0;
            this.top = valueTop - myHeight;
        } else if (close <= yAxis.min) {
            const valueBottom =  yAxis.toPixels(yAxis.min) ?? 0
            this.top = valueBottom - myHeight;
        }

        if (this.top < 0) {
            this.top = 0;
        }
        
        this.element.findFirst('p')?.setInnerHtml(value);
        this.element.style.top = this.top + 'px';
        this.element.classList.remove('hidden');
    }

    private onResize() {
        this.base.domEvents.onResize(this.id, () => {
            clearTimeout(this.resizeTimmer);
            this.resizeTimmer = setTimeout(() => {
                this.setLastPriceLabelPosition();
            }, 250);
        });
    }

    private subscribeChartService() {
        this.base.chartService.subscribeChartStyleData((chartStyle: ChartStyleSettingsModel) => {
            const lastPriceBgColor = chartStyle.getLastPriceUpColor();
            if (lastPriceBgColor) {
                this.lastPriceBgColor = lastPriceBgColor;
            }
        });
    }    
}
